/**
 * In a string, replace all text that is a dubel underscore __text__ into bold.
 * __text__ into a tag <strong>text</strong>"
 */
export const convertMarkdownStyleBoldToHtml = (inputString = '') => {
  if (!inputString) {
    return '';
  }
  return inputString.replaceAll(/\__(.*?)\__/g, (_, text) => {
    return `<span class="font-xtrabold" >${text}</span>`;
  });
};
